import React from "react";

const AIOverviewLoading = ({
  id,
  dictionary,
}) => {
  return (
    <div
      className="ai-overview"
      id={`${id}-results-summary`}
    >
      <div className="ai-overview__container">
        <div className="ai-overview__header">
          <div className="ai-overview__header-left">
            <svg className="ai-overview__star-icon" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <h3 className="ai-overview__title">{dictionary.AiSummaryTitle || "AI Overview"}</h3>
          </div>
        </div>
        <div className="ai-overview__content">
          <div className="ai-overview__skeleton">
            <div className="ai-overview__skeleton-line ai-overview__skeleton-line--full"></div>
            <div className="ai-overview__skeleton-line ai-overview__skeleton-line--full"></div>
            <div className="ai-overview__skeleton-line ai-overview__skeleton-line--medium"></div>
            <div className="ai-overview__skeleton-line ai-overview__skeleton-line--full"></div>
            <div className="ai-overview__skeleton-line ai-overview__skeleton-line--short"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIOverviewLoading;

